<template>
  <section class="hero">
    <div class="container">
      <header class="header">
        <h1 class="hero-title">
          <p>{{ $t("conference.hero.title1") }}</p>
          <p>
            {{ $t("conference.hero.title2") }}
            <span class="gradient-blur">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </p>
          <p>{{ $t("conference.hero.title3") }}</p>
        </h1>
        <a
          class="register-here"
          :href="`${PATHS.CONFERENCE_REGISTRATION}`"
          target="_blank"
        >
          {{ $t("conference.hero.button") }}
          <span class="arrow"></span>
        </a>
      </header>

      <div class="info">
        <ConferenceInfo class="info-info" />
        <p class="info-text">{{ $t("conference.hero.text") }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import ConferenceInfo from "@/components/common/ConferenceInfo.vue";
import { PATHS } from "@/data/nav";

export default {
  name: "HeroSection",
  components: { ConferenceInfo },
  data() {
    return {
      PATHS,
    };
  },
};
</script>

<style scoped>
.hero {
  background-color: var(--color-primary);
  color: var(--color-off-white);
  /* padding: 162px 0; */
  padding: clamp(3rem, -0.0334rem + 11.2871vw, 10.125rem) 0
    clamp(6.68rem, 5.2133rem + 5.4574vw, 10.125rem);
  background-image: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.2)
    ),
    linear-gradient(0deg, rgba(0, 70, 221, 0.35), rgba(0, 70, 221, 0.35)),
    url("../../assets/images/conference/hero-bg.jpg");
  background-position: center bottom;
  background-size: cover;
  position: relative;
}

.container {
  display: flex;
  flex-direction: column;
  /* gap: 4rem; */
  gap: clamp(1rem, -0.2772rem + 4.7525vw, 4rem);
  position: relative;
}

@media screen and (min-width: 768px) {
  .info {
    order: 1;
  }
  header {
    position: relative;
    order: 2;
  }
}

.info-info {
  font-size: clamp(1rem, 0.8936rem + 0.396vw, 1.25rem);
  line-height: 1.5;
}

.info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.info-text {
  max-width: 394px;
  /* font-size: 1.25rem; */
  font-size: clamp(1rem, 0.8936rem + 0.396vw, 1.25rem);
  line-height: 1.5;
}

.hero-title {
  /* font-size: 6.875rem; */
  font-size: clamp(1.875rem, -0.2537rem + 7.9208vw, 6.875rem);
  line-height: 1.3;
  text-transform: uppercase;
}
@media screen and (max-width: 768px) {
  .hero-title {
    /* font-size: 1.875rem; */
    line-height: 1.4;
  }
  .hero-title p:nth-child(2)::after {
    display: none !important;
  }

  .info-text {
    order: 1;
    margin-bottom: 1rem;
  }
  .info-info {
    order: 2;
  }
}
.hero-title p:first-child {
  text-align: left;
}
.hero-title p:nth-child(2) {
  text-align: center;
  position: relative;
}
.gradient-blur {
  position: absolute;
  z-index: 5;
  inset: auto 0 0 0;
  height: 120%;
  pointer-events: none;
  top: 50%;
  transform: translateY(-45%);
}
.gradient-blur > span,
.gradient-blur::before,
.gradient-blur::after {
  position: absolute;
  inset: 0;
}
.gradient-blur::before {
  content: "";
  z-index: 1;
  backdrop-filter: blur(0.5px);
  mask: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 12.5%,
    rgba(0, 0, 0, 1) 25%,
    rgba(0, 0, 0, 0) 37.5%
  );
}
.gradient-blur > span:nth-of-type(6) {
  z-index: 2;
  backdrop-filter: blur(0.5px);
  mask: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 12.5%,
    rgba(0, 0, 0, 1) 25%,
    rgba(0, 0, 0, 1) 37.5%,
    rgba(0, 0, 0, 0) 50%
  );
}
.gradient-blur > span:nth-of-type(5) {
  z-index: 3;
  backdrop-filter: blur(1px);
  mask: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 25%,
    rgba(0, 0, 0, 1) 37.5%,
    rgba(0, 0, 0, 1) 50%,
    rgba(0, 0, 0, 0) 62.5%
  );
}
.gradient-blur > span:nth-of-type(4) {
  z-index: 4;
  backdrop-filter: blur(2px);
  mask: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 37.5%,
    rgba(0, 0, 0, 1) 50%,
    rgba(0, 0, 0, 1) 62.5%,
    rgba(0, 0, 0, 0) 75%
  );
}
.gradient-blur > span:nth-of-type(3) {
  z-index: 5;
  backdrop-filter: blur(2px);
  mask: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 50%,
    rgba(0, 0, 0, 1) 62.5%,
    rgba(0, 0, 0, 1) 75%,
    rgba(0, 0, 0, 0) 87.5%
  );
}
.gradient-blur > span:nth-of-type(2) {
  z-index: 6;
  backdrop-filter: blur(4px);
  mask: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 62.5%,
    rgba(0, 0, 0, 1) 75%,
    rgba(0, 0, 0, 1) 87.5%,
    rgba(0, 0, 0, 0) 100%
  );
}
.gradient-blur > span:nth-of-type(1) {
  z-index: 7;
  backdrop-filter: blur(8px);
  mask: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 75%,
    rgba(0, 0, 0, 1) 87.5%,
    rgba(0, 0, 0, 1) 100%
  );
}
.gradient-blur::after {
  content: "";
  z-index: 8;
  backdrop-filter: blur(16px);
  mask: linear-gradient(to top, rgba(0, 0, 0, 0) 87.5%, rgba(0, 0, 0, 1) 100%);
}

.hero-title p:last-child {
  text-align: right;
}

.register-here {
  /* font-size: 1.75rem; */
  font-size: clamp(1.5rem, 1.3936rem + 0.396vw, 1.75rem);
  line-height: 1.5;
  font-weight: 400;
  text-transform: uppercase;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: transparent;
  border: 0;
  color: var(--color-off-white);
  font-family: inherit;
  appearance: none;
  cursor: pointer;
  text-decoration: none;

  display: none;
}
@media screen and (max-width: 768px) {
  .register-here {
    position: absolute;
    left: 1rem;
    bottom: -70px;
  }
}
.arrow {
  display: block;
  width: 136px;
  height: 2px;
  margin-left: 145px;
  background-repeat: no-repeat;
  background-size: 155px 18px;
  position: relative;
  background-color: var(--color-off-white);
  transition: width 0.42s ease;
}
.arrow::after {
  content: "";
  background-image: url("../../assets/images/conference/arrow-pointer.svg");
  filter: invert(1);
  display: block;
  width: 20px;
  height: 18px;
  background-size: 20px 18px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

@media screen and (min-width: 768px) {
  .register-here:hover .arrow {
    width: 222px;
  }
}
</style>
